import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import Select from '../form-elements/Select';
import { generateOptionsArray } from '../../../helpers/formHelper';

export const DimensionFilters = ({ options, selectedOptions, onSelectedOptionsChange, onFilterChanged }) => {
    // Check for invalid single choice options
    useEffect(() => {
        const selectedOptionsUpdate = Object.fromEntries(
            ['breite', 'hoehe', 'durchmesser']
                .filter(key => {
                    const selectedOption = selectedOptions[key];
                    return !(isEmpty(selectedOption) || options[key].includes(selectedOption));
                })
                .map(invalidKey => [invalidKey, ''])
        );

        if (!isEmpty(selectedOptionsUpdate)) {
            onSelectedOptionsChange({ ...selectedOptions, ...selectedOptionsUpdate });
        }
    }, [onSelectedOptionsChange, options, selectedOptions]);

    return (
        <div className="uk-grid uk-grid-collapse uk-child-width-1-3" data-uk-grid="">
            <div>
                <Select
                    name="breite"
                    options={generateOptionsArray({
                        values: options.breite,
                        additionalOption: { label: 'Alle', value: '' },
                    })}
                    value={selectedOptions.breite}
                    onChange={onFilterChanged}
                />
            </div>
            <div>
                <Select
                    name="hoehe"
                    options={generateOptionsArray({
                        values: options.hoehe,
                        additionalOption: { label: 'Alle', value: '' },
                    })}
                    value={selectedOptions.hoehe}
                    onChange={onFilterChanged}
                />
            </div>
            <div>
                <Select
                    name="durchmesser"
                    options={generateOptionsArray({
                        values: options.durchmesser,
                        additionalOption: { label: 'Alle', value: '' },
                    })}
                    value={selectedOptions.durchmesser}
                    onChange={onFilterChanged}
                />
            </div>
        </div>
    );
};
